import React from 'react';
import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { avatarUrl } from '../utils/functions';
import ProfileTooltip from './ProfileTooltip';

interface ProfileFieldProps {
  userId: number | string | null | undefined;
  userName?: string;
  size?: number;
}
function ProfileField({ userId, userName = '', size = 30 }: ProfileFieldProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box
        sx={{
          ':hover': {
            cursor: 'pointer',
          },
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <ProfileTooltip userId={userId}>
          <img
            style={{
              height: size,
              width: size,
              borderRadius: '50%',
              border: '1px solid rgba(0,0,0,0.2)',
            }}
            src={avatarUrl(userId)}
            alt={userName}
            onError={(e: any) => {
              e.target.src = avatarUrl(0);
            }}
          />
        </ProfileTooltip>
      </Box>

      {userName}
    </Box>
  );
}

export { ProfileField };
